import useCustomFieldsHook from "@/hooks/use-custom-fields.hook.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useOfferSystemFieldValue } from "@/pages/recruit/offers/components/use-offer-system-field-value.ts";
import { ApiField, ApiFieldTypes } from "@/types/custom-field.types.ts";
import { ApiOffer } from "@/types/recruit/offer.types.ts";
import { HtmlViewer, ListItem } from "@skailer-com/uikit";
import { ReactNode } from "react";

export default function useOfferCustomFieldsHook() {
  const { renderEmployeeName } = useFormatter();
  const { renderCustomFieldListItem, getFieldTitle } = useCustomFieldsHook();
  const getSystemValue = useOfferSystemFieldValue();

  const renderOfferFieldListItem = (field: ApiField, offer: ApiOffer): ReactNode | undefined => {
    if (field.type === ApiFieldTypes.custom) {
      return renderCustomFieldListItem(field, offer.custom_fields ?? []);
    }

    const label = getFieldTitle(field);

    if (field.type === ApiFieldTypes.offer_text) {
      return offer.offer_text ? (
        <ListItem
          emphasis={"middle"}
          preTitle={label}
          titleSlot={<HtmlViewer content={offer.offer_text} />}
        />
      ) : undefined;
    }

    const value = getSystemValue(field.type, {
      date_start: offer.date_start,
      legal_entity: offer.legal_entity?.title ?? null,
      location: offer.location?.title ?? null,
      manager: offer.manager ? renderEmployeeName(offer.manager) : null,
      salary: offer.salary
        ? {
            salary_type: offer.salary.salary_type,
            salary_value: offer.salary.salary_value,
            currency_code: offer.salary.currency?.code ?? null,
          }
        : null,
    });

    return value ? (
      <ListItem preTitle={label} title={value.title} caption={value.caption} />
    ) : undefined;
  };

  return { renderOfferFieldListItem };
}
